var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBurnWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#DA4444",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.333,
  d: "M20 15.815v5.662M18.047 6.758 5.592 28.27a2.264 2.264 0 0 0 1.953 3.397h24.91a2.265 2.265 0 0 0 1.953-3.397L21.953 6.758a2.25 2.25 0 0 0-3.906 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DA4444",
  d: "M20 28.27a1.698 1.698 0 1 0 0-3.396 1.698 1.698 0 0 0 0 3.396"
})));
export default SvgBurnWarning;